import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { User } from 'app/core/user/user.types';
import { environment } from 'environments/environment';
import { map, Observable, of, ReplaySubject, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UserService {
    private _httpClient = inject(HttpClient);
    private _user: ReplaySubject<User> = new ReplaySubject<User>(1);
    private _currentUser: User | null = null;

    set user(value: User) {
        this._currentUser = value;
        this._user.next(value);
    }

    get user(): User | null {
        return this._currentUser;
    }

    get user$(): Observable<User> {
        return this._user.asObservable();
    }

    get(): Observable<User> {
        // Try to restore user from localStorage if not yet emitted
        const storedUser = localStorage.getItem('userData');
        if (storedUser) {
            try {
                const user: User = JSON.parse(storedUser);
                this._currentUser = user;
                this._user.next(user);
                return of(user);
            } catch {
                // fall through
            }
        }
        return this._user.asObservable();
    }

    update(user: User): Observable<any> {
        return this._httpClient
            .patch<User>(`${environment.apiBaseUrl}/users/${user.id}`, user)
            .pipe(
                map((response) => {
                    this._currentUser = response;
                    this._user.next(response);
                })
            );
    }
}
